// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const likesHistoryConfig = {
    title: 'chart.instagram.likes_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.instagram.likes_history_name',
        paid: 'paid_data',
        organic: 'organic_data',
        avg: 'chart.instagram.likes_history_avg'
    },
    id: 'likes_history',
    color: {
        value: 'red',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.facebook.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueColors: [
        'orange',
        'green',
        'blue',
        'red',
        'yellow',
        'purple',
        'pink',
        'aquablue',
        'lightBlue',
        'black',
        'lightaquablue',
        'lightgreen',
        'lightyellow',
        'lightpurple',
        'lightpink',
        'lightorange'
    ],
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.instagram.likes_history_tooltip',
    size: SIZE_50,
    type: 'chart',
    isXAxisDate: true,
    adsDataToken: 'chart.instagram.ads_data_tooltip',
    element: LineChart
};
